import React, {Component} from 'react';
import {Card, Table, Input} from 'antd';
import {ColumnProps} from 'antd/lib/table';

import {Club} from '../../../../interfaces';

interface ParsedClub extends Club {
  key: string;
}

interface Properties {
  dataSource: Array<ParsedClub>;
  columns: Array<ColumnProps<ParsedClub>>;
}

interface State {
  filterString: string;
}

class SelectClub extends Component<Properties, State> {
  constructor(props: Properties) {
    super(props);
    this.state = {filterString: ''};
  }

  changeString = (e: React.ChangeEvent<HTMLInputElement>) => this.setState({filterString: e.target.value});

  getFilteredDatasource(dataSource: Array<ParsedClub>): Array<ParsedClub> {
    const {filterString} = this.state;
    if (filterString) {
      return dataSource.filter(x => x.name.toLowerCase().includes(filterString.toLowerCase()));
    }
    return dataSource;
  }

  render() {
    const {dataSource, columns} = this.props;
    return (
      <>
        <Card bodyStyle={{padding: 10}} style={{marginBottom: 10}}>
          <label>Filter clubs</label>
          <Input value={this.state.filterString} onChange={this.changeString} placeholder={'Filter clubs'} />
        </Card>
        <Card bodyStyle={{padding: 0}}>
          <Table
            style={{background: '#fff'}}
            dataSource={this.getFilteredDatasource(dataSource).sort((a: ParsedClub, b: ParsedClub) => (b.name > a.name ? -1 : 1))}
            columns={columns}
            pagination={false}
          />
        </Card>
      </>
    );
  }
}

export default SelectClub;



// WEBPACK FOOTER //
// ./src/pages/StarterpacksPage/components/SelectClub/components/SelectClub/SelectClub.tsx